
  import DataTable from '~/mixins/dataTable'
  export default {
    name: 'PlayerMessages',
    mixins: [DataTable],
    data: () => ({
      api: 'themes/player/getMessage',
      page: 1,
      panel: [],
      rowPerPageOptions: [10, 20, 50, 100],
      message: null,
      messageTimer: null,
      playerLoading: false
    }),
    computed: {
      newMessage() {
        return this.$store.state.player.messages
      }
    },

    watch: {
      newMessage: {
        handler(newVal) {
          if (!newVal || !Array.isArray(newVal.data) || newVal.data.length === 0) return
          this.playerLoading = true
          if (this.messageTimer) clearTimeout(this.messageTimer)

          this.messageTimer = setTimeout(() => {
            this.message = newVal
            this.playerLoading = false
          }, 1000)
        },
        deep: true,
        immediate: true
      }
    },

    mounted() {
      if (this.message?.data?.length) return
      this.customFilters = {
        start_date: '2021-01-01 00:00:00',
        end_date: this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59',
        is_broadcast: true,
        page: 1,
        limit: 10
      }
      this.API()

      setTimeout(() => {
        this.$store.dispatch('themes/player/getMessageNotificationBadges')
      }, 2000)
    },

    beforeUnmount() {
      if (this.messageTimer) clearTimeout(this.messageTimer)
    },

    methods: {
      changePage(value = null) {
        // If limit was changed, reset page to 1
        if (value === null && this.page !== 1) {
          this.page = 1
        } else if (value !== null) {
          this.page = value
        }
        this.customFilters.page = this.page
        // Fetch new data
        this.API()
      },
      togglePanel(idx) {
        if (this.panel.includes(idx)) {
          this.panel = this.panel.filter(item => item !== idx)
        } else {
          this.panel.push(idx)
        }
      }
    }
  }
